import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const AttachmentListItemContainer = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const AttachmentLink = styled(Link)`
  text-decoration: none;
`;

export const AttachmentInfo = styled.div`
  font-family: var(--font-sans);
  color: var(--color-black);

  .course-title {
    font-size: 1.25rem;
    font-weight: 500;

    margin-bottom: 8px;
  }
`;

export const AttachmentListContainer = styled.ul`
  list-style: none;

  & > :not(:last-child) {
    margin-bottom: 24px;
  }
`;
